import CnLayoutPage from "./cn-layout-page";
import CnLayoutCell from "./cn-layout-cell";
import CnLayoutHeader from "./cn-layout-header";
import CnLayoutFooter from "./cn-layout-footer";
import CnLayoutContent from "./cn-layout-content";
import CnLayoutSection from "./cn-layout-section";
import CnLayoutRow from "./cn-layout-row";
import CnLayoutCol from "./cn-layout-col";
import CnLayoutAside from "./cn-layout-aside";
import CnLayoutBlock from "./cn-layout-block";

// 通过arr控制输出的顺序
var bundle = [CnLayoutPage, CnLayoutCell, CnLayoutHeader, CnLayoutFooter, CnLayoutContent, CnLayoutSection, CnLayoutRow, CnLayoutCol, CnLayoutAside, CnLayoutBlock];
export default bundle;